<template>
  <MetaInfo :title="meta.title" :description="meta.description"></MetaInfo>
  <div>
    <navigation></navigation>

    <IntegrationHeader></IntegrationHeader>

    <IntegrationBody></IntegrationBody>

    <section class="container-fluid mb-40">
      <div class="row">
        <div class="col-xs-12 col-sm-10 col-sm-offset-1">
          <div class="row">
            <div class="col-xs-12">
              <ImageSlider
                v-if="
                  ourApp.screenshots &&
                  typeof ourApp.screenshots == 'object' &&
                  ourApp.screenshots.length > 0
                "
              >
              </ImageSlider>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid">
      <div class="row">
        <div class="col-xs-12 col-sm-10 col-sm-offset-1">
          <footerCTA></footerCTA>
        </div>
      </div>
    </section>

    <site-footer></site-footer>
  </div>
</template>

<script>
import MetaInfo from "@/components/MetaInfo";
import Navigation from "@/components/navigation/Main";
import SiteFooter from "@/components/SiteFooter";
import IntegrationHeader from "@/components/Integrations/IntegrationHeader";
import IntegrationBody from "@/components/Integrations/IntegrationBody";
import ImageSlider from "@/components/ImageSlider/ImageSlider";
import FooterCTA from "@/components/FooterCTA";

import axios from "axios";
import {
  APPLICATIONS_API,
  appConnectUrl,
} from "@/functions/applicationsApi";

const INTEGRATION_META_TITLES = {
  8: "Capsule CRM Integration | Transpond",
  10: "Mailchimp Integration | Transpond",
  15: "Stripe Integration - Connect Payments to Email Marketing | Transpond",
  36: "Trustpilot Integration - Sync Reviews | Transpond",
  41: "Zapier Integration - Automate Your Workflows | Transpond",
  46: "HubSpot Integration - Sync Contacts & Campaigns | Transpond",
  47: "Pipedrive Integration - Sync Contacts & Campaigns | Transpond",
  53: "Slack Integration - Get Campaign Alerts in Slack | Transpond",
  76: "LinkedIn Integration | Transpond",
  94: "Transpond MCP - Connect AI Assistants | Transpond",
};

export default {
  name: "IntegrationDetails",
  components: {
    MetaInfo,
    Navigation,
    SiteFooter,
    IntegrationHeader,
    IntegrationBody,
    ImageSlider,
    FooterCTA,
  },
  data() {
    return {
      blogData: [],
      ourApp: [],
      dataLoaded: false,
      meta: {
        title: "",
        description: "",
      },
    };
  },

  created() {
    axios
      .get(APPLICATIONS_API + "/" + this.$route.params.appId)
      .then((response) => {
        if (!response.data.Application) this.$router.push("/integrations");
        this.ourApp = response.data.Application;

        this.dataLoaded = true;
        this.meta.title =
          INTEGRATION_META_TITLES[String(this.$route.params.appId)] ||
          INTEGRATION_META_TITLES[this.ourApp.id] ||
          `Transpond integration partner - ${this.ourApp.appName}`;
        this.meta.description =
          this.ourApp.appDescription ||
          `Transpond integration partner - ${this.ourApp.appName}`;
      })
      .catch(() => {
        this.$router.push("/integrations");
      });
  },
  methods: {
    installApp() {
      const connectUrl = appConnectUrl(this.ourApp);
      if (connectUrl) {
        window.location.href = connectUrl;
        return;
      }
      window.open(
        "https://app.transpond.io/appconnect?appid=" + this.ourApp.id,
        this.ourApp.id,
        "_self"
      );
    },
  },
};
</script>
